import { Component } from '@grafikr/components';

export default Component((_, { onMounted }) => {
  onMounted(() => {
    const anchorLinks = document.querySelectorAll<HTMLAnchorElement>('a[href^="#"]');
    anchorLinks.forEach((anchor) => {
      anchor.addEventListener('click', function (e) {
        e.preventDefault();

        const elem = document.querySelector<HTMLElement>(anchor.getAttribute('href')!.replace('#', '#anchor-'));
        if (elem) {
          window.scrollTo({
            top: elem.offsetTop - 88,
            behavior: 'smooth',
          });
        }
      });
    });
  });
});
